export default {
    domains: [],
    status: 'loading'
}